import { useEffect, useState } from "react";
import FavoriteButton from "src/pages/DashboardPage/acadia/components/FavoriteButton";
import DialogComponent from "src/components/DialogComponent";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import InputFilterSet from "src/components/InputFilterSet";
import TGButton from "src/components/ui/TGButton";
import SaveIcon from "src/components/ui-icons/SaveIcon";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { SelectedCurrentUser } from "src/modules/users/types";
import { selectCurrentUser } from "src/modules/users/selector";
import { addItemRequest, deleteItemRequest, getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import Loading from "src/components/Loading";
import { MTFavoriteFiltersListName } from "src/api/config/myTasksLists.config";
import CustomRadio from "src/pages/DashboardPage/acadia/components/Tests/components/Ui/CustomRadio";

export const FavoriteButtonFilters = ({ filters, displayFilters, reRenderFilterSettings, setReRenderFilterSettings, filtersParams, type }: { filters: string, displayFilters: string, reRenderFilterSettings: boolean, setReRenderFilterSettings: any, filtersParams: any, type: string }) => {

    const [isSaved, setIsSaved] = useState(false);
    const [isFavorite, setIsFavorite] = useState<{ state: boolean; id: number | null }>({ state: false, id: null });
    const currentUser: SelectedCurrentUser = useAppSelector(selectCurrentUser);
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [filterTitle, setFilterTitle] = useState("");
    const [defaultFilter, setDefaultFilter] = useState(false);
    const [sendFilters, setSendFilters] = useState<any>({});
    const [sendDisplayFilters, setSendDisplayFilters] = useState<any>({});
    const [sendFiltersParams, setSendFiltersParams] = useState<any>({});

    useEffect(() => {
        setLoading(true);
        if (Object.keys(currentUser).length > 0 && currentUser.id > 0) {
            getItemsRequest({ listName: MTFavoriteFiltersListName, filters: { Author: currentUser.id, Type: type } }).then(results => {
                const favoriteFilters = [...results.items.filter((item: any) => item.MTFullFilters === filtersParams)];
                if (favoriteFilters.length > 0) {
                    setIsFavorite({
                        state: true,
                        id: favoriteFilters[0]['ID']
                    });
                } else {
                    setIsFavorite({ state: false, id: null });
                }
                setLoading(false);
            });
        }
    }, [reRenderFilterSettings, filtersParams, currentUser]);

    useEffect(() => {
        if (filters) {
            const tempFilters = { ...JSON.parse(filters) };
            tempFilters.hasOwnProperty('DateIncidents') && delete tempFilters['DateIncidents'];
            tempFilters.hasOwnProperty('DateIncidents2') && delete tempFilters['DateIncidents2'];
            tempFilters.hasOwnProperty('TimeIncident') && delete tempFilters['TimeIncident'];
            tempFilters.hasOwnProperty('Date5Way') && delete tempFilters['Date5Way'];
            tempFilters.hasOwnProperty('DateOb') && delete tempFilters['DateOb'];
            setSendFilters({ ...tempFilters });
        }
    }, [filters]);

    useEffect(() => {
        if (displayFilters) {
            const tempFilters = { ...JSON.parse(displayFilters) };
            tempFilters.hasOwnProperty('DateIncidents') && delete tempFilters['DateIncidents'];
            tempFilters.hasOwnProperty('DateIncidents2') && delete tempFilters['DateIncidents2'];
            tempFilters.hasOwnProperty('TimeIncident') && delete tempFilters['TimeIncident'];
            tempFilters.hasOwnProperty('Date5Way') && delete tempFilters['Date5Way'];
            tempFilters.hasOwnProperty('DateOb') && delete tempFilters['DateOb'];
            setSendDisplayFilters({ ...tempFilters });
        }
    }, [displayFilters]);

    useEffect(() => {
        if (filtersParams) {
            const tempFilters = { ...JSON.parse(filtersParams) };
            tempFilters.hasOwnProperty('DateIncidents') && delete tempFilters['DateIncidents'];
            tempFilters.hasOwnProperty('DateIncidents2') && delete tempFilters['DateIncidents2'];
            tempFilters.hasOwnProperty('TimeIncident') && delete tempFilters['TimeIncident'];
            tempFilters.hasOwnProperty('Date5Way') && delete tempFilters['Date5Way'];
            tempFilters.hasOwnProperty('DateOb') && delete tempFilters['DateOb'];
            setSendFiltersParams({ ...tempFilters });
        }
    }, [filtersParams]);

    const toggleFavorite = () => {
        setLoading(true);
        closeDialog();
        if (!isFavorite.id) {
            getItemsRequest({ listName: MTFavoriteFiltersListName, filters: { Author: currentUser.id, Type: type } }).then(results => {
                const filtersUser = [...results.items];
                if (filtersUser.length > 0) {
                    if (defaultFilter) {
                        let updateFilters: any = [];
                        filtersUser.forEach((filter: any) => {
                            updateFilters = [...updateFilters, {
                                ID: filter.ID,
                                DefaultFilter: false
                            }]
                        });
                        updateItemRequest({ listName: MTFavoriteFiltersListName, body: updateFilters[0], bodyArr: updateFilters }).then(() => {
                            addItemRequest({
                                listName: MTFavoriteFiltersListName,
                                body: {
                                    MTFilters: JSON.stringify(sendFilters),
                                    DisplayFilters: JSON.stringify(sendDisplayFilters),
                                    MTFullFilters: JSON.stringify(sendFiltersParams),
                                    Title: filterTitle,
                                    Type: type,
                                    DefaultFilter: defaultFilter
                                },
                            }).then(id => {
                                setFilterTitle("");
                                setDefaultFilter(false);
                                setReRenderFilterSettings(!reRenderFilterSettings);
                                setLoading(false);
                            });
                        });
                    } else {
                        addItemRequest({
                            listName: MTFavoriteFiltersListName,
                            body: {
                                MTFilters: JSON.stringify(sendFilters),
                                DisplayFilters: JSON.stringify(sendDisplayFilters),
                                MTFullFilters: JSON.stringify(sendFiltersParams),
                                Title: filterTitle,
                                Type: type,
                                DefaultFilter: defaultFilter
                            },
                        }).then(id => {
                            setFilterTitle("");
                            setDefaultFilter(false);
                            setReRenderFilterSettings(!reRenderFilterSettings);
                            setLoading(false);
                        });
                    }
                } else {
                    addItemRequest({
                        listName: MTFavoriteFiltersListName,
                        body: {
                            MTFilters: JSON.stringify(sendFilters),
                            DisplayFilters: JSON.stringify(sendDisplayFilters),
                            MTFullFilters: JSON.stringify(sendFiltersParams),
                            Title: filterTitle,
                            Type: type,
                            DefaultFilter: defaultFilter
                        },
                    }).then(id => {
                        setFilterTitle("");
                        setDefaultFilter(false);
                        setReRenderFilterSettings(!reRenderFilterSettings);
                        setLoading(false);
                    });
                }
            });
        } else {
            deleteItemRequest({
                listName: MTFavoriteFiltersListName,
                ID: isFavorite.id,
            }).then(() => {
                setFilterTitle("");
                setDefaultFilter(false);
                setReRenderFilterSettings(!reRenderFilterSettings);
                setLoading(false);
            })
        }
    }

    function openDialog() {
        setIsSaved(true);
    }

    function closeDialog() {
        setIsSaved(false);
        setFilterTitle("");
    }

    return (
        <>
            {filters &&
                <>
                    {loading &&
                        <FlexCol className="flex w-6 h-6">
                            <Loading />
                        </FlexCol> ||
                        <FavoriteButton isFavorite={isFavorite} onToggle={isFavorite.state && isFavorite.id ? toggleFavorite : openDialog} />
                    }
                    <DialogComponent open={isSaved} toggleDialog={closeDialog}>
                        <FlexCol className="w-full tablet:w-[600px] shrink">
                            <FlexRow className="mb-9">
                                <h3 className="text-black">Назовите набор фильтров</h3>
                            </FlexRow>
                            <FlexRow className="mb-9">
                                <InputFilterSet initial={filterTitle} onChange={setFilterTitle} />
                            </FlexRow>
                            <FlexRow className="mb-[18px] tablet:mb-9">
                                <div className="flex gap-[8px]">
                                    <button onClick={() => setDefaultFilter(!defaultFilter)} className="hover:cursor-pointer">
                                        <CustomRadio checked={defaultFilter} />
                                    </button>
                                    <span className="text-[#111928] text-[14px] tablet:text-[16px]">Установить по умолчанию</span>
                                </div>
                            </FlexRow>
                            <FlexRow className="flex-wrap tablet:flex-nowrap justify-between tablet:px-10 pt-[24px] tablet:pt-10 tablet:-mx-10 border-t gap-[10px] tablet:gap-0">
                                <FlexCol className={"w-full tablet:w-fit order-2 tablet:order-1"}>
                                    <TGButton onClick={closeDialog}>Отмена</TGButton>
                                </FlexCol>
                                <FlexCol className={"w-full tablet:w-fit order-1 tablet:order-2"}>
                                    <TGButton color="bluedark" icon={<SaveIcon />} onClick={toggleFavorite} >
                                        Сохранить
                                    </TGButton>
                                </FlexCol>
                            </FlexRow>
                        </FlexCol>
                    </DialogComponent>
                </>
            }
        </>
    );
};
